import apiClient from './client';

export interface MyCryptoKeys {
  public_jwk: string;
  encrypted_private_jwk: string;
  kdf_salt_b64: string;
  kdf_iterations: number;
  kdf_hash: string;
  priv_enc_alg: string;
  priv_enc_iv_b64: string;
}

export interface PublicKey {
  user_id: number;
  public_jwk: string;
}

export const cryptoApi = {
  getMyKeys: async (): Promise<MyCryptoKeys | null> => {
    const r = await apiClient.get('/api/crypto/keys/me');
    return r.data ?? null;
  },

  upsertMyKeys: async (payload: MyCryptoKeys): Promise<MyCryptoKeys> => {
    const r = await apiClient.post('/api/crypto/keys', payload);
    return r.data;
  },

  getMemberAccessUsers: async (memberId: number): Promise<number[]> => {
    const r = await apiClient.get(`/api/crypto/access/member/${memberId}/users`);
    return r.data.user_ids || [];
  },

  getPublicKeys: async (userIds: number[]): Promise<PublicKey[]> => {
    const r = await apiClient.post('/api/crypto/keys/public', { user_ids: userIds });
    return r.data;
  },
};

